// import React from "react";

// import CategoryFilter from "./CategoryFilter";
// import BrandFilter from "./BrandFilter";
// import ColorFilter from "./ColorFilter";
// import PriceFilter from "./PriceFilter";
// import SizeFilter from "./SizeFilter";

// const FiltersSidebar = ({ 
//   filters, 
//   setFilters, 
//   showCategoryFilter, 
//   brandCounts, 
//   priceBounds 
// }) => {

//   return (
//     <div className="space-y-6 bg-white p-4 rounded-lg shadow-sm">
//       <div className="flex items-center justify-between mb-4">
//       <h3 className="font-semibold text-lg">Filter</h3>
//       <button
//         onClick={() =>
//           setFilters((prev) => ({
//             categories: prev.categories, // keep category
//             brands: [],
//             colors: [],
//             sizes: [],
//             price: {
//               min: null,
//               max: null
//             }
//           }))
//         }
//         className="text-sm text-gray-600 hover:text-blue-800"
//       >
//         Clear all
//       </button>
//       </div>

//       {/* <CategoryFilter filters={filters} setFilters={setFilters} /> */}
//       {showCategoryFilter && (
//         <CategoryFilter
//           filters={filters}
//           setFilters={setFilters}
//         />
//       )}

//       <BrandFilter
//         brandCounts={brandCounts}
//         filters={filters}
//         setFilters={setFilters}
//       />

//       <PriceFilter 
//         filters={filters} 
//         setFilters={setFilters} 
//         priceBounds={priceBounds} 
//       />

//       <SizeFilter filters={filters} setFilters={setFilters} />
//       <ColorFilter filters={filters} setFilters={setFilters} />
//     </div>
//   );
// };

// export default FiltersSidebar;


// import React from "react";

// import CategoryFilter from "./CategoryFilter";
// import BrandFilter from "./BrandFilter";
// import ColorFilter from "./ColorFilter";
// import PriceFilter from "./PriceFilter";
// import SizeFilter from "./SizeFilter";

// const FiltersSidebar = ({
//   filters,
//   setFilters,
//   showCategoryFilter,
//   brandCounts,
//   priceBounds
// }) => {
//   return (
//     <div className="bg-white border border-gray-200 rounded-lg shadow-sm sticky top-4">

//       {/* HEADER */}
//       <div className="flex items-center justify-between px-4 py-3 border-b">
//         <h3 className="font-semibold text-lg">Filters</h3>

//         <button
//           onClick={() =>
//             setFilters((prev) => ({
//               categories: prev.categories, // keep category
//               brands: [],
//               colors: [],
//               sizes: [],
//               price: {
//                 min: null,
//                 max: null
//               }
//             }))
//           }
//           className="text-sm text-blue-600 hover:underline"
//         >
//           Clear All
//         </button>
//       </div>

//       {/* FILTER CONTENT */}
//       <div className="px-4 py-4 space-y-6 max-h-[calc(100vh-140px)] overflow-y-auto">

//         {/* CATEGORY */}
//         {showCategoryFilter && (
//           <div>
//             <h4 className="text-sm font-semibold mb-3">Category</h4>
//             <CategoryFilter
//               filters={filters}
//               setFilters={setFilters}
//             />
//           </div>
//         )}

//         {/* BRAND */}
//         <div>
//           {/* <h4 className="text-sm font-semibold mb-3">Brand</h4> */}
//           <BrandFilter
//             brandCounts={brandCounts}
//             filters={filters}
//             setFilters={setFilters}
//           />
//         </div>

//         {/* PRICE */}
//         <div>
//           {/* <h4 className="text-sm font-semibold mb-3">Price</h4> */}
//           <PriceFilter
//             filters={filters}
//             setFilters={setFilters}
//             priceBounds={priceBounds}
//           />
//         </div>

//         {/* SIZE */}
//         <div>
//           {/* <h4 className="text-sm font-semibold mb-3">Size</h4> */}
//           <SizeFilter
//             filters={filters}
//             setFilters={setFilters}
//           />
//         </div>

//         {/* COLOR */}
//         <div>
//           {/* <h4 className="text-sm font-semibold mb-3">Color</h4> */}
//           <ColorFilter
//             filters={filters}
//             setFilters={setFilters}
//           />
//         </div>

//       </div>
//     </div>
//   );
// };

// export default FiltersSidebar;

import React, { useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  SlidersHorizontal,
  X
} from "lucide-react";

import CategoryFilter from "./CategoryFilter";
import BrandFilter from "./BrandFilter";
import PriceFilter from "./PriceFilter";
import SizeFilter from "./SizeFilter";
import ColorFilter from "./ColorFilter";
import ProductFlagFilter from "./ProductFlagFilter";

const FiltersSidebar = ({
  filters,
  setFilters,
  showCategoryFilter,
  availableSizes,
  colorOptions,
  brandCounts,
  categoryCounts,
  priceBounds,
  preserveCategories = [],
  onClose
}) => {
  const [open, setOpen] = useState({
    category: true,
    brand: true,
    price: true,
    size: true,
    color: true,
    flags: true
  });

  const toggle = (key) =>
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <aside className="bg-white border rounded-lg flex flex-col h-full">

      {/* HEADER */}
      <div className="p-4 border-b flex items-center justify-between">
        <SlidersHorizontal size={24} />
        <div className="flex items-center justiffy-between w-full px-2 gap-4">
          <h3 className="font-semibold text-lg">Filter</h3>
          {/* RESET */}

          {/* <button
            onClick={() =>
              setFilters((prev) => ({
                categories: preserveCategories,
                brands: [],
                colors: [],
                sizes: [],
                price: { min: null, max: null },
                flags: {
                  bestSeller: false,
                  newArrivals: false
                }
              }))
            }
            className="w-full text-gray-600 font-semibold text-sm text-right hover:underline"
          >
            Clear all
          </button> */}
          {!onClose && (
            <button
              onClick={() =>
                setFilters((prev) => ({
                  categories: preserveCategories,
                  brands: [],
                  colors: [],
                  sizes: [],
                  price: { min: null, max: null },
                  flags: {
                    bestSeller: false,
                    newArrivals: false
                  }
                }))
              }
              className="w-full text-gray-600 font-semibold text-sm text-right hover:underline"
            >
              Clear all
            </button>
          )}

        </div>

        {onClose && (
          <button onClick={onClose}>
            <X size={18} />
          </button>
        )}
      </div>

      {/* FILTER BODY */}
      <div className="flex-1 overflow-y-auto px-3 py-2 space-y-2">

        {/* CATEGORY */}
        {showCategoryFilter && (
          <Section
            title="Category"
            open={open.category}
            onToggle={() => toggle("category")}
          >
            <CategoryFilter
              filters={filters}
              setFilters={setFilters}
              categoryCounts={categoryCounts}
            />
          </Section>
        )}

        {/* PRODUCT FLAGS */}
        <Section
          title="Product Type"
          open={open.flags}
          onToggle={() => toggle("flags")}
        >
          <ProductFlagFilter
            filters={filters}
            setFilters={setFilters}
          />
        </Section>


        {/* BRAND */}
        <Section
          title="Brand"
          open={open.brand}
          onToggle={() => toggle("brand")}
        >
          <BrandFilter
            brandCounts={brandCounts}
            filters={filters}
            setFilters={setFilters}
          />
        </Section>

        {/* PRICE */}
        <Section
          title="Price Range"
          open={open.price}
          onToggle={() => toggle("price")}
        >
          <PriceFilter
            filters={filters}
            setFilters={setFilters}
            priceBounds={priceBounds}
          />
        </Section>

        {/* SIZE */}
        <Section
          title="Size"
          open={open.size}
          onToggle={() => toggle("size")}
        >
          <SizeFilter
            filters={filters}
            setFilters={setFilters}
            availableSizes={availableSizes}
          />
        </Section>

        {/* COLOR */}
        <Section
          title="Color"
          open={open.color}
          onToggle={() => toggle("color")}
        >
          <ColorFilter
            filters={filters}
            setFilters={setFilters}
            colorOptions={colorOptions}
          />
        </Section>
      </div>
    </aside>
  );
};

export default FiltersSidebar;

/* ---------------- SECTION COMPONENT ---------------- */

const Section = ({ title, open, onToggle, children }) => {
  return (
    <div className="border rounded-md">
      <button
        onClick={onToggle}
        className="w-full flex justify-between items-center px-4 py-3 bg-gray-50"
      >
        <span className="font-medium text-sm">{title}</span>
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>

      {open && <div className="px-4 py-3">{children}</div>}
    </div>
  );
};
